module.exports = __webpack_public_path__ + "files/88b7d3cd4f2d008e1e378c77dcd8cb74.png";